<template>
  <div>
    <van-action-sheet
      :closeable="false"
      v-model="innerShowActions"
      :cancel-text="l.id_cancel_btn"
      class="action-sheet"
      :round="false"
    >
      <div class="action-btn-list">
        <div class="from-album" @click="album">
          {{ l.id_select_idcard_from_album }}
        </div>
        <div class="dividing van-hairline--top"></div>
        <div class="from-camera" @click="camera">
          {{ l.id_select_idcard_from_camera }}
        </div>
      </div>
    </van-action-sheet>
    <van-popup class="popup-show" v-model="popupShow">
      <div class="title">{{ l.id_select_idcard_eg }}</div>
      <div class="main-img">
        <van-image
          fit="cover"
          width="141px"
          height="90px"
          :src="popImg.mainImg"
        />
      </div>
      <div class="main-tip">{{ l.id_popup_select_text }}</div>
      <div class="detail-list">
        <div class="detail-item">
          <van-image
            fit="cover"
            width="62px"
            height="55px"
            :src="popImg.detail1"
          />
          <div class="item-tip">
            {{ l.id_select_idcard_detail_1 }}
          </div>
        </div>
        <div class="detail-item">
          <van-image
            fit="cover"
            width="62px"
            height="55px"
            :src="popImg.detail2"
          />
          <div class="item-tip">
            {{ l.id_select_idcard_detail_2 }}
          </div>
        </div>
        <div class="detail-item">
          <van-image
            fit="cover"
            width="62px"
            height="55px"
            :src="popImg.detail3"
          />
          <div class="item-tip">
            {{ l.id_select_idcard_detail_3 }}
          </div>
        </div>
      </div>

      <div @click="clickKnow">
        <Uploader
          class="uploader-init"
          :deletable="false"
          :name="echoField"
          preview-size="100%"
          max-count="1"
          :capture="capture"
          :preview-full-image="false"
          :before-read="beforeRead"
          :after-read="afterRead"
        >
          <template #default>
            <div class="btn">
              {{ l.id_select_know }}
            </div>
          </template>
        </Uploader>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Compressor from "compressorjs";
import { IMAGE_LIMIT } from "../../utils/config";
import { lrzUploadImage } from "../../services/upload";
import { Uploader, Image, ActionSheet, Popup } from "vant";
import l from "../../locales";

const positiveMain = require("../../assets/icon/positive_main.png");
const positiveDetail1 = require("../../assets/icon/positive_1.png");
const positiveDetail2 = require("../../assets/icon/positive_2.png");
const positiveDetail3 = require("../../assets/icon/positive_3.png");

const backMain = require("../../assets/icon/back_main.png");
const backDetail1 = require("../../assets/icon/back_1.png");
const backDetail2 = require("../../assets/icon/back_2.png");
const backDetail3 = require("../../assets/icon/back_3.png");

export default {
  components: {
    Uploader,
    [Image.name]: Image,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
  },
  props: {
    isClickClose: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    echoField: {
      type: String,
      default: "",
    },
  },
  watch: {
    showActions(newVal) {
      this.innerShowActions = newVal;
    },
    innerShowActions(newVal) {
      this.$emit("update:showActions", newVal);
    },
  },
  data() {
    return {
      l: l.idCard,
      innerShowActions: false,
      popupShow: false,
      capture: "",
      popImg: {
        mainImg: null,
        detail1: null,
        detail2: null,
        detail3: null,
      },
    };
  },
  methods: {
    clickKnow() {
      // 点击知道了关闭弹窗
      if (this.isClickClose) {
        this.popupShow = false;
        this.innerShowActions = false;
      }
    },
    album() {
      //从相册选择
      if (this.echoField == "imgIdCardPositive") {
        this.popImg.mainImg = positiveMain;
        this.popImg.detail1 = positiveDetail1;
        this.popImg.detail2 = positiveDetail2;
        this.popImg.detail3 = positiveDetail3;
      } else if (this.echoField == "imgIdCardBack") {
        this.popImg.mainImg = backMain;
        this.popImg.detail1 = backDetail1;
        this.popImg.detail2 = backDetail2;
        this.popImg.detail3 = backDetail3;
      }
      // console.log("album从相册选择", this.isClickClose, this.showActions, this.echoField);
      this.capture = undefined;
      this.popupShow = true;
    },
    camera() {
      //拍照
      if (this.echoField == "imgIdCardPositive") {
        this.popImg.mainImg = positiveMain;
        this.popImg.detail1 = positiveDetail1;
        this.popImg.detail2 = positiveDetail2;
        this.popImg.detail3 = positiveDetail3;
      } else if (this.echoField == "imgIdCardBack") {
        this.popImg.mainImg = backMain;
        this.popImg.detail1 = backDetail1;
        this.popImg.detail2 = backDetail2;
        this.popImg.detail3 = backDetail3;
      }
      // console.log("camera拍照", this.isClickClose, this.showActions, this.echoField);
      this.capture = "camera";
      this.popupShow = true;
    },
    // 图片修正
    beforeRead(file, detail, i = 1) {
      // console.log("beforeRead", file);
      // loading
      this.$emit("beforeRead", this.echoField);
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        let quality = 1;
        let len = IMAGE_LIMIT * (1024 * 1024);
        if (file.size > len) {
          quality = 0.5 ** i;
        }
        // 会将图片修正为正确方向
        new Compressor(file, {
          checkOrientation: true,
          quality: quality,
          success: async (result) => {
            let nowFile = new File([result], result.name, {
              type: file.type,
            });
            if (i >= 2) {
              // console.log("2次压缩结束");
              resolve(result);
            } else if (result.size > len) {
              resolve(this.beforeRead(nowFile, detail, Number(i) + 1));
            } else {
              // console.log("成功压缩");
              resolve(result);
            }
          },
          error(err) {
            console.log("beforeRead", err);
          },
        });
      });
    },
    // 上传拦截
    afterRead(file) {
      let vm = this;
      // console.log("afterRead111", file);
      lrzUploadImage(file.file, this.echoField, (results, url) => {
        // this.formData[detail.name] = url;
        vm.$emit("afterRead", results, vm.echoField, url);
        vm.popupShow = false;
        vm.innerShowActions = false;
      });
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
}
.action-sheet {
  width: 92%;
  padding: 0 4%;
  background: rgba(0, 0, 0, 0);
  .van-action-sheet__gap {
    background: rgba(0, 0, 0, 0);
  }
  .van-action-sheet__cancel {
    background: #ffffff;
    height: 50px;
    border-radius: 10px;
    margin-bottom: 15px;
    font-family: PingFangSC-Medium;
    font-size: 15px;
    color: #00819F;
  }
  .action-btn-list {
    .dividing::after {
      background: #c6c6c6;
    }
    > div:first-child {
      background: #f0f0f0;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #00819F;
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin-top: 15px;
      border-radius: 10px 10px 0 0;
    }
    > div:last-child {
      background: #f0f0f0;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #00819F;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 0 0 10px 10px;
    }
  }
}
.popup-show {
  width: 271px;
  background: #ffffff;
  border-radius: 5px;
  padding: 16px 15px;
  .title {
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .main-img {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
  .main-tip {
    margin-top: 15px;
    text-align: center;
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #999999;
  }
  .detail-list {
    margin-top: 15px;
    display: flex;
    justify-content: space-around;
    .detail-item {
      .item-tip {
        text-align: center;
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #999999;
      }
    }
  }
  .uploader-init {
    width: 100%;
    /deep/ .van-uploader__input-wrapper {
      width: 100% !important;
    }
  }
  .btn {
    margin-top: 11px;
    text-align: center;

    height: 44px;

    background: #00819F;
    border-radius: 11px;

    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 44px;
  }
}
</style>
